
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/survey/migraine-v4",
      function () {
        return require("private-next-pages/survey/migraine-v4/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/survey/migraine-v4"])
      });
    }
  